import { render, staticRenderFns } from "./SmtpCampaignStatistics.vue?vue&type=template&id=22c9d373&scoped=true"
import script from "./SmtpCampaignStatistics.vue?vue&type=script&lang=js"
export * from "./SmtpCampaignStatistics.vue?vue&type=script&lang=js"
import style0 from "./SmtpCampaignStatistics.vue?vue&type=style&index=0&id=22c9d373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c9d373",
  null
  
)

export default component.exports